import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'pdf-download-button',
    templateUrl: './pdf-download-button.component.html',
    styleUrls: ['./pdf-download-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PdfDownloadButtonComponent {
    @Input('data-src')
    public src!: string;
}
